module.exports = __webpack_public_path__ + "static/media/downhill.2a278b15.png";